"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoidState = void 0;
const ui_1 = require("@jsonjoy.com/ui");
const VoidMenu_1 = require("./VoidMenu");
const EmbedButtonState_1 = require("./embed/EmbedButtonState");
const FileButtonState_1 = require("./file/FileButtonState");
class VoidState {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.open = ui_1.rsync.val(false);
        this.start = () => {
            return () => { };
        };
        this.close = () => {
            this.open.set(false);
            this.mutxt.api.focus();
        };
        this.menu = new VoidMenu_1.VoidMenu(mutxt);
        this.embed = new EmbedButtonState_1.EmbedButtonState(mutxt);
        this.file = new FileButtonState_1.FileButtonState(mutxt);
    }
    point() {
        try {
            const focusRect = this.mutxt.api.focusRect();
            if (!focusRect)
                return;
            return {
                x: focusRect.left,
                y: focusRect.bottom + 4,
                dx: 0,
                dy: 1,
            };
        }
        catch {
            return;
        }
    }
}
exports.VoidState = VoidState;
